import * as types from './mutation-types'
import { convertIntToBoolean } from '@/helpers'

let defaultObject = () => ({
  data: {}
})

export default {
  [types.SET_ACTIVITIE] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    convertIntToBoolean(payload, ['status'])
    state.activitie = payload
  },
  [types.SET_ACTIVITIES] (state, payload) {
    state.activities = []
    if (payload.data.length > 0) {
      for (let activitie of payload.data) {
        convertIntToBoolean(activitie, ['status'])
      }
      state.activities = payload.data
    }
    state.pagination = payload.meta.pagination
  }
}
